import { css } from '@emotion/react'

export const baseStyles = ({ theme }) => css`
  position: relative;
  padding: ${theme.spacings.mega} ${theme.spacings.byte};
`

export const textStyles =
  ({ theme }) => css`
    color: ${theme.colors.n800};
    font-size: 14px;
  `

export const iconStyles = css`
  display: block;
  width: 18px;
  cursor: pointer;
`

export const menuStyles =
  ({ theme, active }) => css`
    display: none;
    position: absolute;
    top: 14px;
    right: 32px;
    min-width: max-content;
    padding: 0;
    margin: 0;
    background: ${theme.colors.white};
    box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
    border: 1px solid ${theme.colors.n100};
    border-radius: ${theme.borderRadius.mega};
    transition: opacity 100ms ease;
    will-change: transform,opacity;

    ${active
? css`
      display: block;
    `
: ''}
  `

export const itemStyles =
  ({ theme }) => css`
    display: block;
    position: relative;
    height: auto;
    padding: ${theme.spacings.byte} ${theme.spacings.mega};
    border: none;
    border-top: none;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.n100};
    }
  `
